import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=337162f5"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337162f5')) {
      api.createRecord('337162f5', component.options)
    } else {
      api.reload('337162f5', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=337162f5", function () {
      api.rerender('337162f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/premium/edit.vue"
export default component.exports